export default __webpack_public_path__ + "static/media/neoronio-active.50eb81e0.svg";